import { render, staticRenderFns } from "./TvCouponPanel.vue?vue&type=template&id=10766ec8&scoped=true"
import script from "./TvCouponPanel.vue?vue&type=script&lang=js"
export * from "./TvCouponPanel.vue?vue&type=script&lang=js"
import style0 from "./TvCouponPanel.vue?vue&type=style&index=0&id=10766ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10766ec8",
  null
  
)

export default component.exports